import React, { useEffect, useState } from "react";
import OrderMealAdditionModal from "../../modals/OrderMealAdditionModal";
import OrdersGridAddOnsModal from "./OrdersGridAddonsModal";
import { Card, Checkbox } from "antd";
import { getAdditionGroupsBreakdown } from "../../../services/order-add-edit-service";
import { getTotalPriceOfSelectedItems } from "../../../services/order-common-service";

const ManageAddOns = ({
  foodQuantity,
  addOns,
  selectedAddOns,
  additionGroups,
  onHandleAddOnsChange,
  onSaveAdditionGroups,
  paymentStatus,
}) => {
  const [isGroupsModalOpen, setIsGroupsModalOpen] = useState(false);
  const [isAddOnsModalOpen, setIsAddOnsModalOpen] = useState(false);
  const [additionGroupsBreakDown, setAdditionGroupsBreakdown] = useState([]);

  function onHandleSelectedAddOns(e, val) {
    const isChecked = e.target.checked;
    const tempSelectedAddOns = [...selectedAddOns];

    if (isChecked) {
      if (!tempSelectedAddOns.some((addOn) => addOn.id === val.id)) {
        tempSelectedAddOns.push({ ...val });
      }
    } else {
      const index = tempSelectedAddOns.findIndex((addOn) => addOn.id === val.id);
      if (index !== -1) {
        tempSelectedAddOns.splice(index, 1);
      }
    }

    console.log('*****In ManageAddOns**********', {tempSelectedAddOns});

    onHandleAddOnsChange(tempSelectedAddOns);
  }

  useEffect(() => {
    const breakdownGroups = getAdditionGroupsBreakdown(additionGroups, foodQuantity);
    setAdditionGroupsBreakdown(breakdownGroups);
  }, [additionGroups, foodQuantity]);

  return (
    <div className="mt-2">
      <div className="flex justify-left gap-[10px]">
        {addOns?.length > 0 && (
          <button
            disabled={paymentStatus === 1}
            className={`w-[59px] h-[20px] rounded-[28px] text-[10px] font-bold
          ${paymentStatus === 1 ? "bg-[#D5D8DB]" : "bg-[#FCBD10]"}`}
            onClick={() => setIsAddOnsModalOpen(true)}
          >
            Add-Ons
          </button>
        )}

        {additionGroups.length > 0 && (
          <button
            disabled={paymentStatus === 1}
            className={`w-[100px] h-[20px] rounded-[28px] text-[10px] font-bold
          ${paymentStatus === 1 ? "bg-[#D5D8DB]" : "bg-[#FCBD10]"}`}
            onClick={() => setIsGroupsModalOpen(true)}
          >
            Meal Addition
          </button>
        )}
      </div>

      {/* selected addons */}
      {selectedAddOns.length > 0 && (
        <div className="mt-[14px] w-[calc(100%-100px)]">
          <div className="font-semibold">Add-ons</div>
          {selectedAddOns.map((selectedAddOn) => (
            <div className="py-[2px]" key={selectedAddOn.id}>
              <Checkbox
                checked={true}
                onChange={(e) => onHandleSelectedAddOns(e, selectedAddOn)}
                className="add-ons-modal-checkbox"
              >
                <h1 className="text-[13px] font-medium leading-[13px]  break-all min-w-0">{selectedAddOn.name}</h1>
              </Checkbox>
            </div>
          ))}
        </div>
      )}
      {/* additionGroups list */}
      {additionGroupsBreakDown.length > 0 && (
        <div className="mt-4 w-full">
          <div className="font-semibold">Meal Additions</div>
          {additionGroupsBreakDown.map((group) => (
            <div key={group.additionGroupId} className="mt-2">
              {/* Group name */}
              {/* Group name */}
              <div className="flex justify-between text-sm font-medium text-gray-700">
                <div className="flex-1  break-all min-w-0">
                  {group.name} [Complimentary - {group.numberOfFreeItems * foodQuantity}]
                </div>
                <div className="flex-shrink-0">
                  {getTotalPriceOfSelectedItems(group, group.additionItems, foodQuantity).toFixed(2)} TK
                </div>
              </div>

              {/* Free Items */}
              {group.additionItemsFree.length > 0 && (
                <div className="ml-3 mt-1">
                  {group.additionItemsFree.map((item) => (
                    <div key={item.additionItemId} className="flex justify-between text-[13px] text-gray-600">
                      <span className="break-words whitespace-normal min-w-0">
                        {item.quantity} × {item.name}
                      </span>
                      <span className="font-semibold flex-shrink-0">0.00 TK</span>
                    </div>
                  ))}
                </div>
              )}

              {/* Paid Items */}
              {group.additionItemsPaid.length > 0 && (
                <div className="ml-3 mt-1">
                  {group.additionItemsPaid.map((item) => (
                    <div key={item.additionItemId} className="flex justify-between text-[13px] text-gray-600">
                      <span className="break-words whitespace-normal min-w-0">
                        {item.quantity} × {item.name}
                      </span>
                      <span className="font-semibold flex-shrink-0">
                        {parseFloat(group.pricePerAddition * item.quantity).toFixed(2)} TK
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <OrderMealAdditionModal
        openModal={isGroupsModalOpen}
        foodQuantity={foodQuantity}
        additionGroups={additionGroups}
        onSaveAdditionGroups={onSaveAdditionGroups}
        setIsGroupsModalOpen={setIsGroupsModalOpen}
      />
      <OrdersGridAddOnsModal
        isAddOnsOpen={isAddOnsModalOpen}
        foodAddOns={addOns}
        handleClose={setIsAddOnsModalOpen}
        onHandleAddOnsOkButton={onHandleAddOnsChange}
        selectedAddOns={selectedAddOns}
      />
    </div>
  );
};

export default ManageAddOns;
